import { GuestModel } from './guest-model';
import { QuestionnaireModel } from './questionnaire-model';
import { EventCodeModel } from './eventcode-model';
import { SubEventCodeModel } from './subeventcode-model';

export class SubEventModel {

    constructor(readonly eventCode: EventCodeModel,
                readonly code: SubEventCodeModel,
                readonly locationShort: string,
                readonly locationFull: string,
                readonly title: string,
                readonly information: string,
                readonly description: string,
                readonly startDateTime: Date,
                readonly endDateTime: Date,
                readonly hasCountDown: boolean,
                readonly questionnaire: Array<QuestionnaireModel>){
    }
}


// WEBPACK FOOTER //
// ./src/app/models/subevent-model.ts